import Cookies from 'js-cookie'
import { showSettings, fixedHeader, sidebarLogo } from '@/settings'
export default {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  pageLoading: false,
  fullscreenLoading: false,
  configs: {},
  showSettings,
  fixedHeader,
  sidebarLogo,
}
